import { PickupCorporateScheduleConfigRepositoryInterface } from "@/data/persistences/repositories/contracts/PickupCorporateScheduleConfigRepositoryInterface";
import { PickupCorporateScheduleConfigMapper } from "@/data/persistences/mappers/PickupCorporateScheduleConfigMapper";
import { PickupCorporateScheduleConfig } from "@/domain/entities/PickupCorporateScheduleConfig";
import { PickupCorporateScheduleConfigEndpoint } from "@/app/infrastructures/endpoints/horde/PickupCorporateScheduleConfigEndpoint";
import ApiService from "@/app/infrastructures/services/ApiService";

export class PickupCorporateScheduleConfigApiRepository
  implements PickupCorporateScheduleConfigRepositoryInterface {
  constructor(
    private service: ApiService,
    private mapper: PickupCorporateScheduleConfigMapper,
    private endpoints: PickupCorporateScheduleConfigEndpoint
  ) {}

  public async loadConfig(
    clientId?: number
  ): Promise<PickupCorporateScheduleConfig> {
    const response = await this.service.invoke(
      "get",
      this.endpoints.loadConfig(clientId)
    );
    return this.mapper.mapResponseToEntity(response);
  }

  public async saveConfig(
    config: PickupCorporateScheduleConfig
  ): Promise<boolean> {
    if (config.isEdit) {
      await this.service.invoke(
        "PATCH",
        this.endpoints.updateConfig(config.scheduleId),
        undefined,
        this.mapper.mapEntityToUpdateRequest(config)
      );
    } else {
      await this.service.invoke(
        "POST",
        this.endpoints.createConfig(),
        undefined,
        this.mapper.mapEntityToCreateRequest(config)
      );
    }
    return true;
  }
}
